import React, { useCallback, useRef } from "react";
import SubtleButton from "./Buttons/SubtleButton";
export default function InfinitePageLoader({
  children,
  loadNextPage,
  loading,
  hasMorePages,
  noMoreContent = <p>No more records</p>,
}) {
  const observerRef = useRef(null);
  // The observer is created once and closes over the props it saw then, so reading
  // hasMorePages directly would leave it stuck on the first value. Keeping the current
  // value on a ref lets the callback see it without tearing the observer down and
  // rebuilding it every time the prop changes.
  const hasMorePagesRef = useRef(hasMorePages);
  hasMorePagesRef.current = hasMorePages;
  const ref = useCallback((r) => {
    if (r !== null) {
      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].intersectionRatio <= 0) return;
          // Asking for a page that does not exist starts a fetch that cancels any
          // refetch already in flight, so a list invalidated after a mutation never
          // gets to update.
          if (!hasMorePagesRef.current) return;
          loadNextPage();
        },
        {
          root: null,
          rootMargin: "100px",
        },
      );
      observerRef.current.observe(r);
    } else if (observerRef.current != null) {
      observerRef.current.disconnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      {children}
      <div ref={ref} className="text-center py-2 text-gray-500 text-xs">
        {hasMorePages ? (
          <SubtleButton
            loading={loading}
            loaderColor="#cccccc"
            onClick={loadNextPage}
          >
            Load More
          </SubtleButton>
        ) : (
          noMoreContent
        )}
      </div>
    </div>
  );
}
